var map = {
	"./angle-left.svg": 1817,
	"./angle.svg": 1818,
	"./arc.svg": 1819,
	"./atomic-design.svg": 1820,
	"./calendar.svg": 1821,
	"./check.svg": 1822,
	"./checkbox.svg": 1823,
	"./checkboxActive.svg": 1824,
	"./checkboxCross.svg": 1825,
	"./checkmarkCircle.svg": 1826,
	"./circle.svg": 1827,
	"./circleArrow.svg": 1828,
	"./circleCheck.svg": 1829,
	"./circleCheckBold.svg": 1830,
	"./circleCrossBold.svg": 1831,
	"./clipboardCheck.svg": 1832,
	"./close.svg": 1833,
	"./copy.svg": 1834,
	"./cross.svg": 1835,
	"./dist.svg": 1836,
	"./docs.svg": 1837,
	"./documentText.svg": 1838,
	"./downloadIcon.svg": 1839,
	"./editIcon.svg": 1840,
	"./exclamationMark.svg": 1841,
	"./facebook.svg": 1842,
	"./facebook_new.svg": 1843,
	"./forwardArrow.svg": 1844,
	"./github.svg": 1845,
	"./google.svg": 1846,
	"./heart.svg": 1847,
	"./home.svg": 1848,
	"./info.svg": 1849,
	"./instagram.svg": 1850,
	"./jest.svg": 1851,
	"./lightbulb.svg": 1852,
	"./linkedin.svg": 1853,
	"./menuBurger.svg": 1854,
	"./moneyHouseIcon.svg": 1855,
	"./pdf.svg": 1856,
	"./pen.svg": 1857,
	"./phone.svg": 1858,
	"./plus.svg": 1859,
	"./quoteLeft.svg": 1860,
	"./react-router.svg": 1861,
	"./react.svg": 1862,
	"./redux.svg": 1863,
	"./searchLense.svg": 1864,
	"./successHouseIcon.svg": 1865,
	"./successIcon.svg": 1866,
	"./suitcase.svg": 1867,
	"./trash.svg": 1868,
	"./upload.svg": 1869,
	"./userTie.svg": 1870,
	"./warningIcon.svg": 1871,
	"./webpack.svg": 1872,
	"./youtube.svg": 1873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1816;